<template>
    <div class="company-no-plan">
        <brand-backdrop />

        <div class="company-no-plan__content">
            <div class="company-no-plan__badge">
                <span class="company-no-plan__glow"></span>
                <span class="company-no-plan__icon">
                    <v-icon size="44" color="error">mdi-alert-decagram-outline</v-icon>
                </span>
            </div>

            <div class="company-no-plan__title">{{ $t('company.no_active_plan_title') }}</div>
            <div class="company-no-plan__message">{{ $t('company.no_active_plan_body') }}</div>

            <logout-button color="error" large block class="company-no-plan__btn" />
        </div>
    </div>
</template>

<script>

import store from '@/store'
import scrollLock from '@/mixins/scrollLock'
import BrandBackdrop from '@/components/common/BrandBackdrop'
import LogoutButton from '@/components/common/inputs/LogoutButton'

export default {
    name: 'CompanyNoPlan',
    components: { BrandBackdrop, LogoutButton },
    mixins: [scrollLock],
    beforeRouteEnter(to, from, next) {
        const account = store.state.account
        const eligible = account?.accountType === 'coach_company' && store.state.coachCompanyBlocked === true
        return eligible ? next() : next({ name: 'splash', replace: true })
    },
}
</script>

<style scoped>

.company-no-plan {
    position: fixed;
    inset: 0;
    z-index: 20;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #06080C;
    padding: calc(40px + var(--safe-area-inset-top, 0px)) 24px calc(40px + var(--safe-area-inset-bottom, 0px));
    overflow-x: hidden;
    overflow-y: auto;
}

.company-no-plan__content {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 380px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    animation: company-no-plan-fade-up .5s ease both;
}

.company-no-plan__badge {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 26px;
    animation: company-no-plan-pop .6s cubic-bezier(.34, 1.56, .64, 1) both;
    animation-delay: .12s;
}

.company-no-plan__glow {
    position: absolute;
    width: 260px;
    height: 260px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(232, 92, 92, 0.26) 0%, rgba(232, 92, 92, 0.1) 45%, transparent 70%);
    filter: blur(8px);
}

.company-no-plan__icon {
    position: relative;
    width: 92px;
    height: 92px;
    border-radius: 50%;
    background: rgba(232, 92, 92, 0.12);
    border: 1px solid rgba(232, 92, 92, 0.32);
    display: flex;
    align-items: center;
    justify-content: center;
}

.company-no-plan__title {
    font-size: 28px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1.15;
    color: #F2F5FA;
}

.company-no-plan__message {
    margin-top: 14px;
    font-size: 14px;
    line-height: 1.55;
    color: rgba(242, 245, 250, 0.7);
}

.company-no-plan__btn {
    margin-top: 28px;
}

@keyframes company-no-plan-fade-up {
    from { opacity: 0; transform: translateY(14px); }
    to { opacity: 1; transform: none; }
}

@keyframes company-no-plan-pop {
    0% { opacity: 0; transform: scale(.7); }
    60% { transform: scale(1.06); }
    100% { opacity: 1; transform: scale(1); }
}

</style>
